import React from "react";
import { Typography, Space, Input, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

interface FinetuneDetailsStepProps {
  displayName: string;
  setDisplayName: (value: string) => void;
  description: string;
  setDescription: (value: string) => void;
  isExporting: boolean;
}

// Helper component for field labels with optional tooltips
const FieldLabel: React.FC<{
  label: string;
  tooltip?: string;
  required?: boolean;
}> = ({ label, tooltip, required = false }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
    <Text strong>
      {label}
      {required && <span style={{ color: "#ff4d4f" }}> *</span>}
    </Text>
    {tooltip && (
      <Tooltip title={tooltip}>
        <InfoCircleOutlined style={{ marginLeft: 8, color: "#8c8c8c" }} />
      </Tooltip>
    )}
  </div>
);

const FinetuneDetailsStep: React.FC<FinetuneDetailsStepProps> = ({
  displayName,
  setDisplayName,
  description,
  setDescription,
  isExporting,
}) => {
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Title level={4}>Finetune Details</Title>
      
      <div style={{ marginBottom: 24 }}>
        <FieldLabel label="Display Name" required />
        <Input
          placeholder="Enter a name for this finetune run"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          disabled={isExporting}
          style={{ marginBottom: 24 }}
          status={!displayName.trim() ? "error" : ""}
        />
        
        <FieldLabel label="Description" tooltip="Optional description for the finetune run" />
        <Input.TextArea
          placeholder="Enter description (optional)"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={4}
          disabled={isExporting}
          style={{ marginBottom: 24 }}
        />
      </div>
    </Space>
  );
};

export default FinetuneDetailsStep; 